import { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css"

import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import CustomDropdownIndicator from "../../../myfin_v2/elements/CustomDropdownIndicator";
import { createAuthorizedCapital, updateAuthorizedCapital } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";

export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#205a46',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '35px',
        height: '35px',
        display: 'flex',
        alignItems: 'center',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 10px',
        display: 'flex',
        alignItems: 'center',
        height: '33px',
    }),
    input: (provided) => ({
        ...provided,
        color: '#205a46',
        margin: 0,
        padding: 0,
        border: 'none !important',
        outline: 'none !important',
        boxShadow: 'none !important',
        background: 'transparent !important',
        display: 'flex',
        alignItems: 'center',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '13px',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#205a46',
        fontSize: '13px',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        height: '33px',
        display: 'flex',
        alignItems: 'center',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#f4faf5'
            : state.isFocused
                ? '#f4faf5'
                : 'transparent',
        color: '#205a46',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        marginBottom: '4px',
         fontWeight: state.isSelected ? 600 : 400,
        ':active': {
            backgroundColor: '#e8f6ed',
            color: '#205a46',
        },
        ':hover': {
            backgroundColor: '#f4faf5',
            color: '#205a46',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};


const AuthorizedCapitalModal = ({ handleClose, data, type, classOfShareOptions, investmentID, refreshData, companyId, onSuccess, onError }) => {

    const animatedComponents = makeAnimated();

    const [selectedClassOfShare, setSelectedClassOfShare] = useState(
        type === "edit" && data?.classOfShare
        ? { label: data.classOfShare, value: data.classOfShare }
        : null
    );
    const [subClass, setSubClass] = useState({ label: "option 1", value: "1" });

     const [noOfShares, setNoOfShares] = useState(
            type === "edit" ? data?.noOfShares : ""
        );

        const [faceValue, setFaceValue] = useState(
            type === "edit" ? data?.faceValue : ""
        );

        const [amount, setAmount] = useState(
            type === "edit" ? data?.amount : ""
        );

        const [loading, setLoading] = useState(false);

        const handleSubmit = async () => {
  try {
    setLoading(true);

    const payload = {
      companyID: companyId,
      classOfShare: selectedClassOfShare?.value || "",
      noOfShares: Number(noOfShares),
      faceValue: Number(faceValue),
      amount: Number(amount),
    };

    let res;

    if (type === "edit") {
      res = await updateAuthorizedCapital(
        investmentID,
        data._id,
        payload
      );
    } else {
      res = await createAuthorizedCapital(investmentID, payload);
    }

    if (res.status === 200) {
      if (onSuccess) {
          onSuccess(type === "edit" ? "Authorized Capital Updated" : "Authorized Capital Created");
      }
      refreshData();
      handleClose();
    }
  } catch (err) {
    console.error(err);
    const errorMsg = err?.response?.data?.error || err?.response?.data?.message || "Failed to save authorized capital";
    if (onError) {
        onError(errorMsg);
    } else {
        swal("Error", errorMsg, "error");
    }
  } finally {
    setLoading(false);
  }
};

    const subClassOptions = [
        { label: "option 1", value: "1" },
        { label: "option 2", value: "2" },
        { label: "option 3", value: "3" },
    ];
    return(
        <>
            <style>
                {`
                    input.no-spinner::-webkit-outer-spin-button,
                    input.no-spinner::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    input.no-spinner[type=number] {
                        -moz-appearance: textfield; /* Firefox */
                    }

                    .input-col > input {
                        border: 1px solid #c2e6d1 !important;
                        background-color: #f4faf5 !important;
                        border-radius: 10px !important;
                        padding: 0 10px !important;
                        height: 35px !important;
                        line-height: 33px !important;
                        color: #205a46 !important;
                        font-size: 14px !important;
                        box-sizing: border-box !important;
                    }

                    div[class*="-control"] input,
                    div[class*="-Input"] input,
                    div[class*="-ValueContainer"] input,
                    .select__control input,
                    .select__input-container input,
                    .select__input,
                    .select__input input,
                    .basic-multi-select input,
                    .input-col div[class*="-control"] input,
                    .input-col .select__control input,
                    .input-col .select__input-container input,
                    .input-col .select__input,
                    .input-col .basic-multi-select input {
                        border: none !important;
                        outline: none !important;
                        box-shadow: none !important;
                        background: transparent !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        height: auto !important;
                        line-height: normal !important;
                        color: #205a46 !important;
                        border-radius: 0 !important;
                    }

                    .select__control {
                        min-height: 35px !important;
                        height: 35px !important;
                        display: flex !important;
                        align-items: center !important;
                    }

                    .select__input-container {
                        display: flex !important;
                        align-items: center !important;
                        margin: 0 !important;
                        padding: 0 !important;
                    }

                    .select__value-container {
                        display: flex !important;
                        align-items: center !important;
                        padding: 0 10px !important;
                        height: 33px !important;
                    }

                    .select__placeholder,
                    .select__single-value {
                        display: flex !important;
                        align-items: center !important;
                        margin: 0 !important;
                        font-size: 14px !important;
                    }
                `}
            </style>
            <Modal
                width="500px"
                title={type === "edit" ? "Edit Authorized Capital" : "Create Authorized Capital"}
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label={type === "edit" ? "Update" : "Create Authorized Capital"}
                            onClick={handleSubmit}
                            disabled={loading}
                         />
                    </>
                }
            >

                <div className={commoncss.pd1530}>
                    <span className="input-label">Class of share</span>
                    <Select
                        placeholder="Enter Class of share"
                        options={classOfShareOptions.map((option) => ({
                            label: option,
                            value: option,
                        }))}
                        className={`basic-multi-select w-100 mt-1 mb-2`}
                        classNamePrefix="select"
                        components={{
                            ...animatedComponents,
                            IndicatorSeparator: () => null,
                            DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={customStyles}
                        value={selectedClassOfShare}
                        onChange={(selectedOption) => setSelectedClassOfShare(selectedOption)}

                    />
                     
                     {/* <span className="input-label mt-2">Sub-class</span>
                        <Select
                        placeholder="Enter Sub class"  
                        options={subClassOptions}
                        className={`basic-multi-select w-100 mt-1 mb-2`}
                        classNamePrefix="select"
                        components={{
                            ...animatedComponents,
                            IndicatorSeparator: () => null,
                            DropdownIndicator: CustomDropdownIndicator,
                        }}
                        styles={customStyles}
                        value={subClass}
                        onChange={(selectedOption) => setSubClass(selectedOption)}
                        /> */}
                   

                    <InputGroup
                        label="No of shares"
                        inputs={[
                        <>
                          <input
                            type="text"
                            inputMode="numeric"
                            placeholder="Enter number of shares"
                            className="no-spinner"
                            value={noOfShares}
                            onChange={(e) => setNoOfShares(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Face value"
                        inputs={[
                        <>
                            <input
                                type="number"
                                placeholder="Enter face value"
                                onWheel={(e) => e.target.blur()}
                                className="no-spinner"
                                value={faceValue}
                                onChange={(e) => setFaceValue(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Amount"
                        inputs={[
                        <>
                            <input
                                type="number"
                                placeholder="Enter amount"
                                onWheel={(e) => e.target.blur()}
                                className="no-spinner"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                </div>
                
            </Modal>
        </>
    )

}

export default AuthorizedCapitalModal;